define("shared/components/shared/wizard", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/object/computed", "@ember/utils", "@ember/runloop", "@ember/service", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _component2, _object, _computed, _utils, _runloop, _service, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/object/computed",0,"@ember/utils",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/tracking",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.setUpSlides}}>
    <Shared::Modal
      @closable={{@closable}}
      @close={{@onFinish}}
      @inline={{@inline}}
      @primaryClass={{this.primaryClass}}
      as
      |modal|
    >
      {{yield (hash
          slide=(component "shared/wizard/slide"
          modal=modal
          finishWizard=(action "finishWizard")
          slideProgressString=this.slideProgressString
          activeSlideId=this.activeSlideId
          isFirstSlide=this.isFirstSlide
          isLastSlide=this.isLastSlide
          registerSlide=(action "registerSlide")
          nextSlide=(action "nextSlide")
            previousSlide=(action "previousSlide")
          )
        )}}
    </Shared::Modal>
  </div>
  
  */
  {
    "id": "M593+BGM",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"setUpSlides\"]]],null],[12],[1,\"\\n  \"],[8,[39,1],null,[[\"@closable\",\"@close\",\"@inline\",\"@primaryClass\"],[[30,1],[30,2],[30,3],[30,0,[\"primaryClass\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[18,5,[[28,[37,3],null,[[\"slide\"],[[50,\"shared/wizard/slide\",0,null,[[\"modal\",\"finishWizard\",\"slideProgressString\",\"activeSlideId\",\"isFirstSlide\",\"isLastSlide\",\"registerSlide\",\"nextSlide\",\"previousSlide\"],[[30,4],[28,[37,5],[[30,0],\"finishWizard\"],null],[30,0,[\"slideProgressString\"]],[30,0,[\"activeSlideId\"]],[30,0,[\"isFirstSlide\"]],[30,0,[\"isLastSlide\"]],[28,[37,5],[[30,0],\"registerSlide\"],null],[28,[37,5],[[30,0],\"nextSlide\"],null],[28,[37,5],[[30,0],\"previousSlide\"],null]]]]]]]]],[1,\"\\n  \"]],[4]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@closable\",\"@onFinish\",\"@inline\",\"modal\",\"&default\"],false,[\"did-insert\",\"shared/modal\",\"yield\",\"hash\",\"component\",\"action\"]]",
    "moduleName": "shared/components/shared/wizard.hbs",
    "isStrictMode": false
  });

  let Wizard = (_dec = (0, _computed.reads)('args.defaultIndex'), _dec2 = (0, _computed.reads)('args.cacheKey'), (_class = class Wizard extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "cache", _descriptor2, this);

      _initializerDefineProperty(this, "activeSlideIndex", _descriptor3, this);

      _initializerDefineProperty(this, "slides", _descriptor4, this);

      _initializerDefineProperty(this, "defaultIndex", _descriptor5, this);

      _initializerDefineProperty(this, "cacheKey", _descriptor6, this);
    }

    get primaryClass() {
      var _this$args$primaryCla;

      return (_this$args$primaryCla = this.args.primaryClass) !== null && _this$args$primaryCla !== void 0 ? _this$args$primaryCla : 'o--modalBg';
    }
    /**
     * Unique element ID of the active slide component
     *
     * @property activeSlideId
     * @type {String}
     */


    get activeSlideId() {
      if (!this.slides.length) {
        return null;
      }

      return this.slides[this.activeSlideIndex].uniqueId;
    }
    /**
     * Returns true if the current slide is the first slide of the wizard
     * (when the index is equal to 0) or that all preceding slides before
     * first active slide has been skipped
     *
     * @property isFirstSlide
     * @type {Boolean}
     */


    get isFirstSlide() {
      const hasNoPrecedingSlides = this.precedingSlides.every(slide => slide.args.skip);
      return this.activeSlideIndex === 0 || hasNoPrecedingSlides;
    }
    /**
     * Returns true if the current slide is the last slide of the wizard
     * (when the index is equal to the length of the wizard minus 1)
     *
     * @property isLastSlide
     * @type {Boolean}
     */


    get isLastSlide() {
      return this.activeSlideIndex === this.slides.length - 1;
    }
    /**
     * Returns an array of slides that precede the current active slide
     *
     * @property precedingSlides
     * @type {Array}
     */


    get precedingSlides() {
      return this.slides.slice(0, this.activeSlideIndex);
    }
    /**
     * Defines whether or not the key is removed
     * from the cache when wizard is completed
     *
     * @property removeFromCacheOnFinish
     * @type {Boolean}
     * @default true
     */


    get removeFromCacheOnFinish() {
      var _this$args$removeFrom;

      return (_this$args$removeFrom = this.args.removeFromCacheOnFinish) !== null && _this$args$removeFrom !== void 0 ? _this$args$removeFrom : true;
    }
    /**
     * Displays the current slide number of the wizard slides
     *
     * @property slideProgressString
     * @type {String}
     */


    get slideProgressString() {
      const skipCount = this.precedingSlides.filter(slide => slide.args.skip).length; // Need to count # of slides before current slide that have been skipped

      const unskippedSlides = this.slides.filter(slide => !slide.args.skip);
      return this.intl.t('wizards.shared.slide_progress', {
        idx: this.activeSlideIndex + 1 - skipCount,
        length: unskippedSlides.length
      });
    }
    /**
     * Sets activeSlideIndex to updated index
     *
     * @method goToSlide
     * @param {Integer} idx
     *
     * @return {Integer} sets activeSlideIndex to updated index
     */


    goToSlide(index) {
      if ((0, _utils.isBlank)(index)) {
        return;
      }

      if (this.cacheKey) {
        this.cache.add(this.cacheKey, index, {
          persist: false,
          expiry: this.cache.maxExpiryDate()
        });
      }

      this.activeSlideIndex = index;
    }

    finishWizard() {
      if (this.args.onFinish) {
        this.args.onFinish();
      }

      if (this.cacheKey && this.args.removeFromCacheOnFinish) {
        this.cache.remove(this.cacheKey);
      }
    }

    nextSlide() {
      return this._navigate('forward');
    }

    previousSlide() {
      return this._navigate('backward');
    }

    registerSlide(slide) {
      _runloop.run.next(() => this.slides = [...this.slides, slide]);
    }
    /**
     * Shows corresponding slide of the validated index
     * If unvalidated, goes to the first slide as the default
     *
     * @method setUpSlides
     */


    setUpSlides() {
      const index = this._getDefaultIndex();

      if (index) {
        _runloop.run.next(() => this._validateIndex(index) ? this.goToSlide(index) : this.goToSlide(0));
      } else {
        this._validateIndex(this.activeSlideIndex) ? this.goToSlide(this.activeSlideIndex) : this.goToSlide(0);
      }
    }
    /**
     * Checks if an default index or cache index value exists
     * and returns that index
     *
     * @method _getDefaultIndex
     *
     * @return {Number} an index
     */


    _getDefaultIndex() {
      if ((0, _utils.isPresent)(this.defaultIndex)) {
        return this.defaultIndex;
      } else if (this.cacheKey) {
        const cacheIndex = this.cache.retrieve(this.cacheKey);

        if ((0, _utils.isPresent)(cacheIndex)) {
          return cacheIndex;
        }
      }
    }
    /**
     * Increments the activeSlideIndex if parameter passed in is true,
     * decrements if false
     *
     * @method _navigate
     * @param {Boolean} next
     *
     * @return {goToSlide} calls goToSlide method with index passed in
     */


    _navigate() {
      let direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'forward';

      if (direction !== 'forward' && direction !== 'backward') {
        throw new Error("Wizard component _navigate function must receive either 'forward' or 'backward' as a parameter. Received ".concat(direction));
      }

      const incrementor = direction === 'forward' ? 1 : -1;
      let index = this.activeSlideIndex + incrementor;

      while (this.slides[index].args.skip) {
        index += incrementor;
      }

      return this.goToSlide(index);
    }
    /**
     * Validates whether the index refers to a slide that exists
     *
     * @method _validateIndex
     * @param {Integer} index
     *
     * @return {Boolean}
     */


    _validateIndex(index) {
      return index >= 0 && index < this.slides.length;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "activeSlideIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "slides", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "defaultIndex", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cacheKey", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "finishWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "finishWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "nextSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "previousSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "registerSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUpSlides", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setUpSlides"), _class.prototype)), _class));
  _exports.default = Wizard;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, Wizard);
});